import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { hideClearAllCartModel } from "../Actions/ClearAllCartPopUp.action";
import { translate } from "../Services/translation";
import {clearAllCart} from "../Actions/Checkout.action";
class ClearAllCartPopUpContainer extends Component {
  constructor(props) {
    super(props);  
  }
  
  getStatus() {
    return this.props["showClearAllcartPop"] == null ? false : this.props["showClearAllcartPop"];
  }

  clearAllCartAndReloadPage(){
    this.props.clearAllCart();
    window.location.reload();
  }
  
  render() {
    const { hideClearAllCartModel, clearAllCart } = this.props;
    return (
      <Fragment>
        {this.getStatus() && (
          <Fragment>
            <div className="modal">
              <div className="modal__bg--overlay" onClick={() => hideClearAllCartModel()}></div>
              <div className="modal__inner">
                <a className="modal__close" onClick={() => hideClearAllCartModel()}>
                  <svg>
                    <use href="/ui/images/sprites/be-group.svg#close"></use>
                  </svg>
                </a>

                <div className="modal__icon">
                  <svg>
                    <use href="/ui/images/sprites/be-group.svg#thumbsup"></use>
                  </svg>
                </div>

                <div className="modal__text">
                  <p>{translate("checkout.clearallcart.title")}</p>
                  <h3>{translate("checkout.clearallcart.subtitle")}</h3>
                </div>

                <div className="modal__actions">
                  <a className="button button--transparent" onClick={() => hideClearAllCartModel()}>  {translate("checkout.cart.popupclose")}</a>
                  <a className="button button--orange" onClick={() => this.clearAllCartAndReloadPage()}> {translate("checkout.clearallcart.clearallcart")}</a>
                </div>
              </div>
            </div>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { checkout,clearallcartpopup } = state;
  return {
    ...checkout,
    ...clearallcartpopup
  };
};



const mapDispatchToProps = (dispatch) => {
  return {
    hideClearAllCartModel: () => dispatch(hideClearAllCartModel()),
    clearAllCart: () => {
       dispatch(clearAllCart());
    },
    clearAllCart: () => {    
      dispatch(clearAllCart());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClearAllCartPopUpContainer);
